import { createFileRoute } from '@tanstack/react-router';
import { SitesLocationsPanel } from '../../../features/settings/components/SitesLocationsPanel';

/** Sites & locations CRUD (BUILD_SPEC.md §5.1, §5.2) — NOT silo calibration,
 * which is G22's sole ownership (plan.md QC fix #3). Plan.md G26. */
export const Route = createFileRoute('/_authenticated/settings/sites-locations')({
  component: SitesLocationsPanel,
});
